var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex text-muted align-items-center mr-3"},[_c('i',{staticClass:"mr-1 mr-md-0 mr-lg-1 pr-1 gf-icon gf-icon-comment"}),_c('span',[_vm._v(_vm._s(_vm.getCounter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }